export const isValidDraftFilename = (filename) => {
    //alphanumeric, hyphen, underscore, periods and whitespace (but not only whitespace)
    const regex = /^(?!\s*$)[a-zA-Z0-9_-\s\.]*$/;
    if (typeof filename !== "string" || !regex.test(filename)) {
        return false;
    }
    return true;
};
